<div class="history-sidebar-skeleton-loading history-timeline-viewport">
    <div class="" style="">
        <div class="d-flex entry-grey flex-row history-timeline-entry m-2 ">
            <div class="history-timeline-entry-icon">
                <div class="rounded-square icon-square box-loading">
                    <div class="d-flex justify-content-center align-items-center h-100 history-timeline-image">
                    </div>
                </div>
            </div>
            <div class="flex-grow-1">
                <div class="card">
                    <div class="card-body p-1 pr-2 pl-2">
                        <p class="card-title text-break history-timeline-entry-title pb-2">
                            <a class="">
                                <div mode="list" class="field field-mode-list field-type-varchar">
                                    <div class="dynamic-field dynamic-field-mode-list dynamic-field-type-varchar ">
                                        <div class="box-loading medium-size-text-skeleton large-length-text-skeleton rounded skeleton-field-content">
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </p>
                        <div class="card-text history-timeline-entry-user pb-2 text-uppercase">
                            <small class="text-break">
                                <div mode="list" class="field field-mode-list field-type-varchar">
                                    <div class="dynamic-field dynamic-field-mode-list dynamic-field-type-varchar ">
                                        <div class="box-loading small-size-text-skeleton small-length-text-skeleton rounded skeleton-field-content">
                                        </div>
                                    </div>
                                </div>
                            </small>
                        </div>
                        <div class="card-text text-break history-timeline-entry-date pb-1">
                            <small class="font-italic">
                                <div mode="list" class="field field-mode-list field-type-datetime">
                                    <div class="dynamic-field dynamic-field-mode-list dynamic-field-type-datetime ">
                                        <div class="box-loading small-size-text-skeleton medium-length-text-skeleton rounded skeleton-field-content">
                                            <span class=""></span>
                                        </div>
                                    </div>
                                </div>
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="" style="">
        <div class="d-flex entry-grey flex-row history-timeline-entry m-2 ">
            <div class="history-timeline-entry-icon">
                <div class="rounded-square icon-square box-loading">
                    <div class="d-flex justify-content-center align-items-center h-100 history-timeline-image">
                    </div>
                </div>
            </div>
            <div class="flex-grow-1">
                <div class="card">
                    <div class="card-body p-1 pr-2 pl-2">
                        <p class="card-title text-break history-timeline-entry-title pb-2 box-loading">
                            <a class="">
                            <span mode="list" class="field field-mode-list field-type-varchar">
                                <div class="dynamic-field dynamic-field-mode-list dynamic-field-type-varchar ">
                                    <div class="box-loading medium-size-text-skeleton large-length-text-skeleton rounded skeleton-field-content">
                                    </div>
                                </div>
                            </span>
                            </a></p>
                        <div class="card-text history-timeline-entry-user pb-2 text-uppercase">
                            <small class="text-break">
                                <div mode="list" class="field field-mode-list field-type-varchar">
                                    <div class="dynamic-field dynamic-field-mode-list dynamic-field-type-varchar ">
                                        <div class="box-loading small-size-text-skeleton small-length-text-skeleton rounded skeleton-field-content">
                                        </div>
                                    </div>
                                </div>
                            </small>
                        </div>
                        <div class="card-text text-break history-timeline-entry-date pb-1 ">
                            <small class="font-italic">
                            <span mode="list" class="field field-mode-list field-type-datetime">
                                <div class="dynamic-field dynamic-field-mode-list dynamic-field-type-datetime ">
                                    <div class="box-loading small-size-text-skeleton medium-length-text-skeleton rounded skeleton-field-content">
                                        <span class=""> </span>
                                    </div>
                                </div>
                            </span>
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="" style="">
        <div class="d-flex entry-grey flex-row history-timeline-entry m-2 ">
            <div class="history-timeline-entry-icon">
                <div class="rounded-square icon-square box-loading">
                    <div class="d-flex justify-content-center align-items-center h-100 history-timeline-image">
                    </div>
                </div>
            </div>
            <div class="flex-grow-1">
                <div class="card">
                    <div class="card-body p-1 pr-2 pl-2">
                        <p class="card-title text-break history-timeline-entry-title pb-2"><a
                                class="">
                            <div mode="list" class="field field-mode-list field-type-varchar">
                                <div class="dynamic-field dynamic-field-mode-list dynamic-field-type-varchar ">
                                    <div class="box-loading medium-size-text-skeleton large-length-text-skeleton rounded skeleton-field-content">
                                    </div>
                                </div>
                            </div>
                        </a></p>
                        <div class="card-text history-timeline-entry-user pb-2 text-uppercase">
                            <small class="text-break">
                                <div mode="list" class="field field-mode-list field-type-varchar">
                                    <div class="dynamic-field dynamic-field-mode-list dynamic-field-type-varchar ">
                                        <div class="box-loading small-size-text-skeleton small-length-text-skeleton rounded skeleton-field-content">
                                        </div>
                                    </div>
                                </div>
                            </small>
                        </div>
                        <div class="card-text text-break history-timeline-entry-date pb-1">
                            <small class="font-italic">
                                <div mode="list" class="field field-mode-list field-type-datetime">
                                    <div class="dynamic-field dynamic-field-mode-list dynamic-field-type-datetime ">
                                        <div class="box-loading small-size-text-skeleton medium-length-text-skeleton rounded skeleton-field-content">
                                            <span class=""> </span>
                                        </div>
                                    </div>
                                </div>
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="" style="">
        <div class="d-flex entry-grey flex-row history-timeline-entry m-2 ">
            <div class="history-timeline-entry-icon">
                <div class="rounded-square icon-square box-loading">
                    <div class="d-flex justify-content-center align-items-center h-100 history-timeline-image">
                    </div>
                </div>
            </div>
            <div class="flex-grow-1">
                <div class="card">
                    <div class="card-body p-1 pr-2 pl-2">
                        <p class="card-title text-break history-timeline-entry-title pb-2"><a
                                class="">
                            <div mode="list" class="field field-mode-list field-type-varchar">
                                <div class="dynamic-field dynamic-field-mode-list dynamic-field-type-varchar ">
                                    <div class="box-loading medium-size-text-skeleton large-length-text-skeleton rounded skeleton-field-content">
                                    </div>
                                </div>
                            </div>
                        </a></p>
                        <div class="card-text history-timeline-entry-user pb-2 text-uppercase">
                            <small
                                    class="text-break">
                                <div mode="list" class="field field-mode-list field-type-varchar">
                                    <div class="dynamic-field dynamic-field-mode-list dynamic-field-type-varchar ">
                                        <div class="box-loading small-size-text-skeleton small-length-text-skeleton rounded skeleton-field-content">
                                        </div>
                                    </div>
                                </div>
                            </small>
                        </div>
                        <div class="card-text text-break history-timeline-entry-date pb-1">
                            <small
                                    class="font-italic">
                                <div mode="list" class="field field-mode-list field-type-datetime">
                                    <div class="dynamic-field dynamic-field-mode-list dynamic-field-type-datetime ">
                                        <div class="box-loading small-size-text-skeleton medium-length-text-skeleton rounded skeleton-field-content">
                                            <span class=""> </span>
                                        </div>
                                    </div>
                                </div>
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="" style="">
        <div class="d-flex entry-grey flex-row history-timeline-entry m-2 ">
            <div class="history-timeline-entry-icon">
                <div class="rounded-square icon-square box-loading">
                    <div class="d-flex justify-content-center align-items-center h-100 history-timeline-image">
                    </div>
                </div>
            </div>
            <div class="flex-grow-1">
                <div class="card">
                    <div class="card-body p-1 pr-2 pl-2">
                        <p class="card-title text-break history-timeline-entry-title pb-2"><a
                                class="">
                            <div mode="list" class="field field-mode-list field-type-varchar">
                                <div class="dynamic-field dynamic-field-mode-list dynamic-field-type-varchar ">
                                    <div class="box-loading medium-size-text-skeleton large-length-text-skeleton rounded skeleton-field-content">
                                    </div>
                                </div>
                            </div>
                        </a></p>
                        <div class="card-text history-timeline-entry-user pb-2 text-uppercase">
                            <small
                                    class="text-break">
                                <div mode="list" class="field field-mode-list field-type-varchar">
                                    <div class="dynamic-field dynamic-field-mode-list dynamic-field-type-varchar ">
                                        <div class="box-loading  small-size-text-skeleton small-length-text-skeleton rounded skeleton-field-content">
                                        </div>
                                    </div>
                                </div>
                            </small>
                        </div>
                        <div class="card-text text-break history-timeline-entry-date pb-1">
                            <small class="font-italic">
                                <div mode="list" class="field field-mode-list field-type-datetime">
                                    <div class="dynamic-field dynamic-field-mode-list dynamic-field-type-datetime ">
                                        <div class="box-loading small-size-text-skeleton medium-length-text-skeleton rounded skeleton-field-content">
                                            <span class="">  </span>
                                        </div>
                                    </div>
                                </div>
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="" style="">
        <div class="d-flex entry-grey flex-row history-timeline-entry m-2 ">
            <div class="history-timeline-entry-icon">
                <div class="rounded-square icon-square box-loading">
                    <div class="d-flex justify-content-center align-items-center h-100 history-timeline-image">
                    </div>
                </div>
            </div>
            <div class="flex-grow-1">
                <div class="card">
                    <div class="card-body p-1 pr-2 pl-2">
                        <p class="card-title text-break history-timeline-entry-title pb-2">
                            <a class="">
                                <div mode="list" class="field field-mode-list field-type-varchar">
                                    <div class="dynamic-field dynamic-field-mode-list dynamic-field-type-varchar ">
                                        <div class="box-loading medium-size-text-skeleton large-length-text-skeleton rounded skeleton-field-content">
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </p>
                        <div class="card-text history-timeline-entry-user pb-2 text-uppercase">
                            <small class="text-break">
                                <div mode="list" class="field field-mode-list field-type-varchar">
                                    <div class="dynamic-field dynamic-field-mode-list dynamic-field-type-varchar ">
                                        <div class="box-loading small-size-text-skeleton small-length-text-skeleton rounded skeleton-field-content">
                                        </div>
                                    </div>
                                </div>
                            </small>
                        </div>
                        <div class="card-text text-break history-timeline-entry-date pb-1">
                            <small class="font-italic">
                                <div mode="list" class="field field-mode-list field-type-datetime">
                                    <div class="dynamic-field dynamic-field-mode-list dynamic-field-type-datetime ">
                                        <div class="box-loading small-size-text-skeleton medium-length-text-skeleton rounded skeleton-field-content">
                                            <span class=""></span>
                                        </div>
                                    </div>
                                </div>
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
